// src/connection/protocol.ts

import type { BrowserToRelayMessage, RelayToBrowserMessage } from '../types';

/**
 * Encode message for sending to relay
 */
export function encodeMessage(msg: BrowserToRelayMessage): string {
  return JSON.stringify(msg);
}

/**
 * Decode message received from relay
 */
export function decodeMessage(data: string): RelayToBrowserMessage {
  const parsed = JSON.parse(data);

  if (!parsed || typeof parsed.type !== 'string') {
    throw new Error('Invalid message: missing type field');
  }

  // Validate known message types (including E2EE and File Explorer types)
  const validTypes = [
    'connected', 'connection_failed', 'session_pending', 'session_ready', 'output', 'encrypted_output',
    'session_ended', 'error', 'server_shutdown', 'pong',
    // File Explorer messages
    'dir_contents', 'cwd_changed', 'encrypted_file_data',
    // Multi-session messages
    'session_created', 'session_closed', 'scrollback_data', 'session_state_changed',
  ];
  if (!validTypes.includes(parsed.type)) {
    throw new Error(`Invalid message type: ${parsed.type}`);
  }

  return parsed as RelayToBrowserMessage;
}

/**
 * Encode binary data as base64
 */
export function encodeData(data: Uint8Array | string): string {
  if (typeof data === 'string') {
    const encoder = new TextEncoder();
    const bytes = encoder.encode(data);
    return btoa(String.fromCharCode(...bytes));
  }
  return btoa(String.fromCharCode(...data));
}

/**
 * Decode base64 data to bytes
 */
export function decodeData(base64: string): Uint8Array {
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return bytes;
}
